// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__4xLsr","rotate":"Chevron_rotate__2-ec8"};